export default "__VITE_ASSET__gD3nS0mt__"